import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!this.element.contains(e.target)) {
        this.hide();
      }
    });

    // Close dropdown when pressing Escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.hide();
      }
    });
  }

  toggle() {
    if (window.matchMedia("(max-width: 1023px)").matches) {
      this.menuTarget.classList.toggle("hidden");
    }
  }

  hide() {
    if (window.matchMedia("(max-width: 1023px)").matches) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
